export default __webpack_public_path__ + "static/media/README.7607dd94.md";